import React from "react";

const CustomInput = ({
  type = "text",
  placeholder = "",
  value = "",
  onChange,
  onBlur,
  disabled = false,
  className = "",
  name = "",
  id = "",
  ...props
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      className={`custom-input ${className}`}
      name={name}
      id={id}
      {...props}
    />
  );
};

export default CustomInput;

